import React from "react";
import { Timer, X, Phone } from "lucide-react";
import * as S from "./styles";
import { OrderAddress, OrderTotal, OrderExtraInfo, ItemCustomizations } from "../OrderDetails";

const OrderCard = ({ order, onNext, onCancel, icon, label, isReadOnly }) => {
  const time = order.created_at
    ? new Date(order.created_at).toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      })
    : "--:--";

  const whatsappUrl = order.customer_whatsapp
    ? `https://wa.me/55${order.customer_whatsapp.replace(/\D/g, "")}`
    : "#";

  return (
    <S.CardStyled status={order.status} isReadOnly={isReadOnly}>
      <header>
        <div className="user-info">
          <strong>{order.customer_name}</strong>
          <div className="sub-info">
            <small>
              <Timer size={14} /> {time}
            </small>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noreferrer"
              className="whatsapp-link"
            >
              <Phone size={14} /> {order.customer_whatsapp}
            </a>
          </div>
        </div>
        <div className="actions-header">
          <span className="order-id">#{order.id.toString().slice(-3)}</span>
          {!isReadOnly && (
            <S.RefuseButton onClick={onCancel} title="Cancelar Pedido">
              <X size={18} />
            </S.RefuseButton>
          )}
        </div>
      </header>

      <OrderAddress order={order} />

      <S.ItemsList>
        {(order.items || []).map((item, i) => (
          <li key={item.id || i}>
            <span className="qty">{item.quantity}</span>
            <span className="name">
              {item.name}
              <ItemCustomizations item={item} />
            </span>
          </li>
        ))}
      </S.ItemsList>

      <OrderExtraInfo order={order} />

      <div className="footer-card">
        <OrderTotal value={order.total_price} />
        {!isReadOnly && (
          <S.ActionButton onClick={onNext} variant={order.status}>
            {icon} <span>{label}</span>
          </S.ActionButton>
        )}
      </div>
    </S.CardStyled>
  );
};

export default OrderCard;
